module.exports = __webpack_public_path__ + "img/pago-efectivo-p.ca6ea112.png";